var exports = {
  "kL": "MediaVolumeControl.module__container___OVNVeW",
  "_s": "MediaVolumeControl.module__muteButton___OVNVeW",
  "Zp": "MediaVolumeControl.module__sliderWrapper___OVNVeW",
  "aw": "MediaVolumeControl.module__slider___OVNVeW",
  "NB": "MediaVolumeControl.module__sliderTrack___OVNVeW",
  "lw": "MediaVolumeControl.module__sliderFill___OVNVeW",
  "eW": "MediaVolumeControl.module__sliderThumb___OVNVeW",
  "Id": "MediaVolumeControl.module__isDragging___OVNVeW",
  "oE": "MediaVolumeControl.module__compact___OVNVeW",
};

module.exports = exports;
